module.exports = function() {
  return new Worker(__webpack_public_path__ + "bc4d687a65bec16fbdd7.worker.js");
};